var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-view","mode":"out-in"}},[(_vm.view)?_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')]),_c('div',{staticClass:"preloader-msg",domProps:{"innerHTML":_vm._s(_vm.setMsg)}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }